/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import {
  Component,
  ViewChild,
  ElementRef,
  HostListener,
  OnInit,
} from '@angular/core';
import { UserService, User } from '../../services/user.service';
import { LoginModalComponent } from '../modals/login-modal.component';
import { RemainingCreditsModalComponent } from '../modals/remaining-credits-modal.component';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { XdaStringsService } from '../../services/xda-strings.service';
import { AccessListService } from '../../services/access-list.service';
import { MyAccountComponent } from '../accounts/my-account.component';
import { LoginService } from '../../services/login.service';

@Component({
  selector: 'nav-account',
  templateUrl: './nav-account.component.html',
  styleUrls: [
    './nav-account.component.less',
    '../../../styles/appTheme-xids.scss',
  ],
  standalone: false,
})
export class NavAccountComponent implements OnInit {
  isExpanded = false;
  // TODO: If we decide we want help link re-enable
  displayHelp = false;
  displayCredits = false;
  userLogoutSub: Subscription;
  accessListDiscoveredSub: Subscription;

  @ViewChild('homeLogin') homeLogin: NgbPopover;

  constructor(
    private element: ElementRef,
    private userService: UserService,
    private loginService: LoginService,
    private accessListService: AccessListService,
    private modalService: NgbModal,
    public router: Router,
    private xdaStringsService: XdaStringsService,
  ) {}

  ngOnInit() {
    this.userLogoutSub = this.userService.userLoggedOff.subscribe(() =>
      this.userLoggedOff(),
    );
    this.accessListDiscoveredSub = this.userService.discovered.subscribe(() =>
      this.updateDisplayCredits(),
    );

    this.updateDisplayCredits();
  }

  updateDisplayCredits() {
    // Display credits like normal in portal only if and they are using the full feature version of the app
    this.displayCredits =
      (this.userService.shouldDisplayCredits() &&
        this.xdaStringsService.strings['FULL_FEATURE'] == 'true') ||
      false;
  }

  userLoggedOff() {
    this.displayCredits = false;
  }

  getUserName() {
    return this.userService.user
      ? this.userService.user.first_name
      : this.xdaStringsService.strings['SDE_LOG_IN'];
  }

  getFullName() {
    return this.userService.user
      ? `${this.userService.user.first_name} ${this.userService.user.last_name}`
      : '';
  }

  collapse() {
    if (this.homeLogin) {
      this.homeLogin.close();
    }
    this.isExpanded = false;
  }

  openAccountModal() {
    if (this.isExpanded) {
      this.collapse();
      this.modalService.open(MyAccountComponent, { windowClass: 'xrx-modal' });
    }
  }

  loginOrToggle() {
    // if user is logged in, expand dropdown
    if (this.userService.user && !this.userService.isGuestUser) {
      if (this.homeLogin) {
        this.homeLogin.open();
        this.isExpanded = true;
      } else {
        this.isExpanded = !this.isExpanded;
      }
    } else {
      // login user
      if (this.xdaStringsService.strings['AGCLOUDAUTH'] == 'true') {
        this.loginService.initiateWebLogin();
      } else {
        this.modalService.open(LoginModalComponent, {
          windowClass: 'xrx-modal',
        });
      }
    }
  }

  logout() {
    this.collapse();
    this.userService.logOff();
    this.userLoggedOff();
  }

  showRemainingCredits() {
    this.isExpanded = false;
    this.modalService.open(RemainingCreditsModalComponent, {
      windowClass: 'xrx-modal',
    });
  }

  @HostListener('document:click', ['$event'])
  onClickGlobal(event: Event) {
    // If dropdown is expanded, and click event comes from outside this element, collapse
    if (this.isExpanded && !this.element.nativeElement.contains(event.target))
      this.collapse();
  }
}
